import "../../Components/Page/Page.css";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";


const DeRisking: React.FC = () => {
    return (
        <div className="sectionContainer">
            <SecHeader title="De-Risking" />
            <SubSection isSplit={false}>
                <div className="description-container">
                    <b>Tariff-Proofing​​</b>
                    <p>
                        <ul>
                            <li>ICE GEMS is “Tariff – Proof” since we encourage producing new engines and parts in all countries</li>
                            <li>We are U.S. made, owned, and IP-controlled, with 100% in-house product production</li>
                            <li>We are predicted to give shareholders their investment amounts or more in dividends in the next 5-6 years</li>
                        </ul>
                    </p>{" "}
                    <b>Policy-Proofing​​</b>
                    <p>
                        <ul>
                            <li>ICE GEMS is “Policy – Proof” since ELF-Tech improves energy resilience, jobs, environmental impacts, climates, 
                                manufacturing, tech leadership, and public policies</li>
                        </ul>
                    </p>{" "}
                    <b>Future-Proofing ​​</b>
                    <p>
                        <ul>
                            <li>ELF-Tech engines can use exiting fuels more cleanly and efficiently</li>
                            <li>They can be used to retrofit exiting vehicles, saving jobs and factories, complying with short term policies.​</li>
                            <li>As new Net-0-CO2 fuels fuels are discovered, ELF-Tech offers the best ways to improve environmental impacts and climate and ICE GEMS is “Future-Proof” for the next 50 years. </li>
                            {/* <li>As new Net-0-CO2 fuels are discovered, Elf-Tech offers the best ways to incorperate improvemtents to environmental impacts and climate </li>
                            <li>As new Net-0-CO2 fuels are discovered, ELF-Tech offers the best ways to 
                                improve environmental impacts, climates, and jobs
                                ​​</li> */}
                        </ul>
                    </p>{" "}
                    
                </div>
            </SubSection>
        </div>
    );
};

export default DeRisking;